import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.455 1.11 4.463 0 0 4.994.005 5 0 5.006 4.463 10l.992-1.11L1.978 5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }